import { Component } from '@angular/core';

@Component({
    selector: 'lsq-browser-not-supported-page',
    template: `
        <div class="row" style="padding-top: 3rem; padding-left: 7.5rem;">
            <lsq-unsupported-browser-modal></lsq-unsupported-browser-modal>
        </div>
    `
})
export class LsqBrowserNotSupportedPageComponent {}
